export type ProviderReferenceHolder = {
  asset_id: string;
  client_id: string;
  client_full_name: string | null;
  adviser_full_name: string | null;
  is_joint: boolean;
};

const describeHolder = ({ client_full_name, adviser_full_name }: ProviderReferenceHolder) => {
  if (client_full_name) {
    return adviser_full_name
      ? `${client_full_name} (adviser ${adviser_full_name})`
      : client_full_name;
  }
  return adviser_full_name ? `a client of ${adviser_full_name}` : 'another client';
};

export const describeProviderReferenceHolders = (holders: ProviderReferenceHolder[]) =>
  new Intl.ListFormat('en-GB', { style: 'long', type: 'conjunction' }).format(
    holders.map(describeHolder),
  );

export const describeSharedReferenceResolution = ({
  involvesPension,
  ownersEnabled,
}: {
  involvesPension: boolean;
  ownersEnabled: boolean;
}) => {
  if (involvesPension) {
    return "A pension can't be held jointly, so one of the references is probably wrong. Automatic valuations are paused until it's corrected.";
  }
  const jointControl = ownersEnabled ? 'turn on "Joint asset"' : 'answer yes to "Is this joint?"';
  return `If this is a joint holding, ${jointControl} on each client's copy; otherwise one of the references is probably wrong. Automatic valuations are paused until then.`;
};
